export var RewardTransactionAction;
(function (RewardTransactionAction) {
    RewardTransactionAction["AdViewed"] = "AdViewed";
    RewardTransactionAction["PostCreated"] = "PostCreated";
    RewardTransactionAction["PostLiked"] = "PostLiked";
    RewardTransactionAction["CommentCreated"] = "CommentCreated";
    RewardTransactionAction["DiscountRedeemed"] = "DiscountRedeemed";
    RewardTransactionAction["BusinessClaimed"] = "BusinessClaimed";
    RewardTransactionAction["EventAttended"] = "EventAttended";
})(RewardTransactionAction || (RewardTransactionAction = {}));
